import { COLORS } from 'helpers/globals'

export default {
  container: {
    position: 'absolute',
    width: '100%'
  },
  content: {
    position: 'absolute',
    top: 0,
    left: 0,
    background: 'white',
    borderRadius: '.5rem',
    boxShadow: '0px 2px 10px 2px rgba(0, 0, 0, 0.5)',
    display: 'flex',
    flexDirection: 'column',
    fontSize: '1.4rem',
    overflow: 'hidden',
    maxWidth: '370px',
    color: 'black',
    '& button': { fontSize: '1.4rem' }
  },
  header: {
    background: COLORS.tertiary,
    color: COLORS.danger,
    padding: '.5rem',
    display: 'flex',
    alignItems: 'center',
    fontSize: '1.6rem',
    fontWeight: 400
  },
  warning: {
    fontSize: '1.6rem',
    marginRight: '.5rem'
  },
  buttonWrapper: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    padding: '0 .5rem .5rem .5rem'
  },
  confirmButton: {
    background: COLORS.danger,
    '&:hover': { background: '#E60000' }
  },
  cancelButton: {
    marginLeft: '1rem',
    background: COLORS.quaternary,
    '&:hover': { background: COLORS.quaternaryHover }
  },
  arrow: {
    position: 'absolute',
    top: 0,
    left: 0,
    width: 0,
    height: 0,
    borderRight: '6px solid transparent',
    borderLeft: '6px solid transparent',
    borderBottom: `8px solid ${COLORS.tertiary}`
  }
}



// WEBPACK FOOTER //
// ./src/components/DoorControllerModelSelector/ChangeModelWarning/style.js